/* eslint-disable */
import React from 'react'
import {message, Pagination} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import {Button, Container, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import Select from 'react-select'
import AutoComplete from '../BaseComponent/autocomplete'
class SearchProduct extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      multiProduct: [],
      productArr: [],
      products: [],
      productModal: false,
      searchTablevisibility: false,
      searchesProduct: [],
      partSearchProduct: [],
      lengthProducts: 0,
      search: '',
      pageNumber: 1,
      current: 1,
      selectedStockProductIds: [],
      arrayOfStocks: [],
      finalStocks: [],

      selectedItem: [],
      allSelectedItem: [],
      allProviders: this.props.providers ? this.props.providers : [],
      providerId: null
    }
  }

  componentDidMount() {}

  openModalProducts() {
    if (!this.state.allProviders.length) {
      // http.get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`,{
      // }).then((response)=>{
      //     if(response.data.error==null){
      //         var provider = response.data.object;
      //         for (let i = 0; i < provider.length; i++) {
      //             provider[i]['value'] = provider[i].providerId;
      //             provider[i]['label'] =provider[i].providerId +' - '+ provider[i].title;
      //         }
      //         this.setState({
      //             allProviders:response.data.object
      //         })
      //     }
      //     else{
      //         this.setState({
      //             allProviders:[]
      //         })
      //     }
      // })
    }

    if (this.props.providerId) {
      this.state.providerId = this.props.providerId
    }

    this.setState(
      {
        modalProduct: true
      },
      () => {
        let searchesProduct = this.state.searchesProduct
        searchesProduct.forEach((item) => {
          item.isChecked = false
        })
        this.setState({
          searchesProduct,
          partSearchProduct: this.state.searchesProduct.slice((1 - 1) * 7, 1 * 7)
        })
      }
    )
  }

  toggleProduct = () => {
    this.setState({
      modalProduct: !this.state.modalProduct
    })
  }

 

  cancelModalProduct = () => {
    this.setState({
      modalProduct: !this.state.modalProduct
    })
  }

  searchProduct(e) {
    let productName = document.getElementById('productName').value.trim()
    let productCode = document.getElementById('productCode').value.trim()
    let articleId = document.getElementById('articleId').value.trim()
    let providerId = this.state.providerId ? this.state.providerId : ''
    if (productName === '' && productCode === '' && articleId === '' && providerId === '') {
      message.error('حداقل یک فیلد وارد شود')
    } else {
      http
        .get(
          `${
            REPORT_RETAIL.REPORT_RETAIL_PRODUCT
          }?export=true&productName=${productName}&productCode=${productCode}&providerId=${providerId}&articleId=${articleId}&pageSize=7&pageNumber=1`,
          {}
        )
        .then((response) => {
          if (response.data.error == null) {
            let result = response.data.object.result
            for (let i = 0; i < result.length; i++) {
              result[i]['isChecked'] = false
            }
            this.setState({
              searchesProduct: response.data.object.result,
              searchTablevisibility: true,
              lengthProducts: response.data.object.countAll,
              partSearchProduct: response.data.object.result.slice(0, 7)
            })
          } else {
            this.setState({
              searchesProduct: [],
              partSearchProduct: []
            })
          }
        })
        .catch((error) => {})
    }
  }

  submitForm(e) {
    e.preventDefault()
  }

  onChangePagination(pageNumber) {
    this.setState({
      current: pageNumber,
      partSearchProduct: this.state.searchesProduct.slice((pageNumber - 1) * 7, pageNumber * 7)
    })
  }

  changeCheckBox = (numId, pageNum) => {
    this.setState(() => {
      let newSearchesProduct = this.state.searchesProduct
      newSearchesProduct[numId - 1].isChecked = !newSearchesProduct[numId - 1].isChecked
      return {
        searchesProduct: newSearchesProduct,
        partSearchProduct: this.state.searchesProduct.slice((pageNum - 1) * 7, pageNum * 7)
      }
    })
  }

  selectProduct = () => {
    let selectedItem = this.state.searchesProduct.filter((i) => i.isChecked)
    let allSelectedItem = this.state.allSelectedItem
    if (selectedItem.length === 0) {
      message.error('محصول مورد نظر را انتخاب کنید سپس تایید کنید')
    } else {
      this.setState(
        {
          modalProduct: false
        },
        () => {
          selectedItem.forEach((item) => {
            let findRepetation = allSelectedItem.find((i) => i.productId === item.productId)
            if (!findRepetation) {
              allSelectedItem.push(item)
            }
          })
          this.setState(
            {
              allSelectedItem
            },
            () => {
              this.props.finalStocks(allSelectedItem)
            }
          )
        }
      )
    }
  }

  removeSelectedItem = (index) => {
    let allSelectedItem = this.state.allSelectedItem
    allSelectedItem.splice(index, 1)
    this.setState(
      {
        allSelectedItem
      },
      () => {
        let allSelectedItem = this.state.allSelectedItem
        this.props.finalStocks(allSelectedItem)
      }
    )
  }

  changeProvider = (providerId) => {
    this.setState({
      providerId
    })
  }

  render() {
    const tableVisibile = this.state.searchTablevisibility ? 'block' : 'hide'
    let modalpageNumber = this.state.current
    let pageSize = 7

    return (
      <div className="container-fluid">
        <div className="row mx-0">
          <div className="col-sm-12 col-md-3 pl-0">
            <div className="formComponent pl-0 pr-3">
              <span
                onClick={this.openModalProducts.bind(this)}
                className="btn btn-sm btn-outline-black btn-block rounded"
              >
                افزودن کالا
              </span>
            </div>
          </div>
          {this.state.allSelectedItem.length > 0 && (
            <div
              style={{border: '1px solid #000', borderRadius: '5px'}}
              className="col-sm-12 p-1 col-md-9 d-flex flex-row flex-wrap align-content-center align-items-center"
            >
              <p className="mb-0  font-weight-bold ">کالاهای انتخاب شده :‌ </p>
              {this.state.allSelectedItem.map((item, index) => (
                <>
                  <div
                    className="d-flex flex-row justify-content-between align-items-center align-content-center btn btn-outline-dark btn-sm mx-1"
                    title={item.productName}
                  >
                    <span className="mr-3">{item.productName}</span>
                    <span className="font-weight-bold">{item.stockProductId}</span>
                    <span className={'ml-3 cursor-pointer'} onClick={() => this.removeSelectedItem(index)}>
                      <img src={require('../../image/ignor.svg')} width={10} height={10} />
                    </span>
                  </div>
                </>
              ))}
            </div>
          )}
        </div>

        <Modal isOpen={this.state.modalProduct} toggle={this.toggleProduct} size="lg">
          <ModalBody className="my-0 py-0">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12 col-sm-6 col-md-3 col-lg-3">
                  <figure className="w-100">
                    <label>نام محصول : </label>
                    <input
                      className="form-control"
                      ref={(node) => (this.productName = node)}
                      type="text"
                      id="productName"
                      placeholder="نام محصول را وارد کنید"
                    />
                  </figure>
                </div>
                <div className="col-12 col-sm-6 col-md-2 col-lg-2">
                  <figure className="w-100">
                    <label>کد محصول : </label>
                    <input
                      className="form-control"
                      ref={(node) => (this.articleId = node)}
                      type="text"
                      id="articleId"
                      placeholder="کد محصول را وارد کنید"
                    />
                  </figure>
                </div>
                <div className="col-12 col-sm-6 col-md-2 col-lg-2">
                  <figure className="w-100">
                    <label>بارکد محصول : </label>
                    <input
                      className="form-control"
                      ref={(node) => (this.productCode = node)}
                      type="text"
                      id="productCode"
                      placeholder="بارکد محصول را وارد کنید"
                    />
                  </figure>
                </div>
                <div className="col-12 col-sm-6 col-md-3 col-lg-3">
                  <div className="">
                    <AutoComplete
                    disabled={this.props.providerId}
                      label="تامین کننده "
                      api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                      textField="title"
                      valueField="providerId"
                      id="provider"
                      value={this.state.providerId}
                      setValue={(providerId) => this.setState({providerId})}
                    />
                    {/* <label>تامین کننده  :</label>
                                        <Select
                                            value={this.state.providerId}
                                            onChange={this.changeProvider}
                                            options={this.state.allProviders}
                                            isClearable={true}
                                            placeholder=''
                                        /> */}
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-md-2 col-lg-2 mt-md-4 pt-md-3">
                  <button onClick={this.searchProduct.bind(this)} className="text-center btn-sm btn-primary">
                    جست و جو
                  </button>
                </div>
                <div className="col-12 my-1">
                  {this.state.partSearchProduct.length > 0 ? (
                    <div>
                      <table className="table table-border table-striped searchProductTable mb-0 pb-0">
                        <tbody>
                          <tr className="firstRow">
                            <td>انتخاب</td>
                            <td>ردیف</td>
                            <td>نام محصول</td>
                            <td>کد کالا</td>
                            <td>تامین کننده</td>
                            <td>بارکد</td>
                            <td>واحد</td>
                          </tr>
                          {this.state.partSearchProduct.map((product, index) => (
                            <tr key={index} style={product.isChecked ? {backgroundColor: 'lightBlue'} : {}}>
                              <td>
                                <input
                                  type="checkbox"
                                  value={product.stockProductId}
                                  checked={product.isChecked}
                                  onChange={() =>
                                    this.changeCheckBox((modalpageNumber - 1) * pageSize + index + 1, modalpageNumber)
                                  }
                                />{' '}
                              </td>
                              <td>{(modalpageNumber - 1) * 7 + index + 1}</td>

                              <td>{product.productName}</td>
                              <td>{product.articleId}</td>
                              <td>{product.providerName}</td>
                              <td>{product.productCode}</td>
                              <td>{product.productUnitTitle}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <div className="paginationWrapp">
                        <Pagination
                          defaultCurrent={1}
                          total={this.state.lengthProducts}
                          onChange={this.onChangePagination.bind(this)}
                        />
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="cancelBtnModal" onClick={this.cancelModalProduct}>
              بستن
            </button>
            <button className="confirmBtnModal" onClick={this.selectProduct}>
              انتخاب
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}
export default SearchProduct
